let Data = {
  pointer: [
    {
      pointername: "Loream",
    },
    {
      pointername: "Loream",
    },
    {
      pointername: "Loream",
    },
    {
      pointername: "Loream",
    },
    {
      pointername: "Loream",
    },
  ],
  termsconditionlistData: [
    {
      title: "DEFINITIONS",
      items: [
        `"Content" means all text, graphics, images, software, and other materials on the Website.`,
        `"Intellectual Property Rights" means all patents, trademarks, service marks, copyrights, database rights, and other intellectual property rights.`,
        `"Services" means any services provided through the Website, including information, support, and other services.`,
        `"User" means any individual or entity that accesses or uses the Website.`,
        `"You" means the User.`,
      ],
    },
    {
      title: "USE OF THE WEBSITE",
      items: [
        `The Website is intended for use by businesses and individuals seeking information about HighMast's services.`,
        `You must use the Website for lawful purposes only.`,
        `You must not use the Website in any way that could damage, disable, overburden, or impair the Website or interfere with any other party's use of the Website.`,
        " You must not attempt to gain unauthorized access to the Website, or any part of it, or any computer systems or networks connected to the Website.",
        " You must not use any automated means, including without limitation, agents, robots, scripts, or spiders, to access, monitor, or copy any part of the Website.",
        " You must not use the Website to transmit or send unsolicited commercial communications.",
      ],
    },
    {
      title: "INTELLECTUAL PROPERTY RIGHTS",
      items: [
        `The Website, including all Content, is owned and operated by HighMast.`,
        `The Intellectual Property Rights in the Website, including all Content, are owned by HighMast or its licensors.`,
        `You have no right to use any of HighMast's Intellectual Property Rights, except as expressly permitted in these Terms.`,
        "You must not copy, reproduce, modify, or distribute any part of the Website, including any Content, without HighMast's prior written consent.",
      ],
    },
    {
      title: "USER RESPONSIBILITIES",
      items: [
        ` You are responsible for ensuring that all information you provide to HighMast is accurate, complete, and up-to-date.`,
        `You are responsible for maintaining the confidentiality of your login credentials (if applicable) and for any activities that occur under your account.`,
        `You must not provide any false or misleading information to HighMast.
`,
        "You must comply with all applicable laws and regulations when using the Website.",
      ],
    },
    {
      title: "DISCLAIMER OF WARRANTIES",
      items: [
        ` The Website and all Content are provided "as is" and "as available" without warranties of any kind, either express or implied.`,
        `HighMast does not warrant that the Website will be uninterrupted, error-free, or free from viruses or other malicious code.`,
        ` HighMast does not warrant that the Content is accurate, complete, or up-to-date.`,
        " You use the Website and Content at your own risk.",
      ],
    },
    {
      title: "LIMITATION OF LIABILITY",
      items: [
        `HighMast will not be liable for any damages, including without limitation, incidental, consequential, or punitive damages, arising out of the use of the Website or Content.`,
        `HighMast's liability for damages will be limited to the amount of fees paid by you to HighMast for the Services.`,
        ` HighMast will not be liable for any damages caused by your breach of these Terms.`,
        " You use the Website and Content at your own risk.",
      ],
    },
    {
      title: "INDEMNIFICATION",
      items: [
        ` You agree to indemnify and hold harmless HighMast, its officers, directors, employees, agents, and affiliates from and against any and all claims, damages, losses, and expenses (including attorney's fees) arising out of or related to your use of the Website, including without limitation, any claims related to your breach of these Terms.`,
      ],
    },
    {
      title: "GOVERNING LAW AND JURISDICTION",
      items: [
        `These Terms will be governed by and construed in accordance with the laws of Singapore.`,
        "Any disputes arising out of or related to these Terms will be resolved through binding arbitration in accordance with the Arbitration Rules of the Singapore International Arbitration Centre.",
        "The language of the arbitration will be English.",
      ],
    },
    {
      title: "CHANGES TO TERMS AND CONDITIONS",
      items: [
        `HighMast reserves the right to modify or update these Terms at any time without prior notice.`,
        "Your continued use of the Website following any changes to these Terms will be deemed acceptance of those changes.",
        "The language of the arbitration will be English.",
      ],
    },
    {
      title: "ADDITIONAL TERMS",
      items: [
        `These Terms constitute the entire agreement between you and HighMast regarding your use of the Website..`,
        "If any provision of these Terms is held to be invalid or unenforceable, that provision will be removed and the remaining provisions will remain in full force and effect.",
        "HighMast's failure to enforce any provision of these Terms will not be deemed a waiver of that provision.",
        "These Terms are binding upon and will inure to the benefit of the parties and their respective successors and assigns.",
      ],
    },
  ],
  PrivacypolicylistData: [
    {
      title: "COLLECTION OF PERSONAL DATA",
      tittle2: "We collect personal data from you when you:",
      items: [
        "Visit our website ",
        "Contact us through our website or by email",
        "Use our services",
        "Interact with us on social media",
      ],
    },
    {
      tittle2: "The personal data we collect may include:",
      items: [
        "Your name and contact information ",
        "Your business contact information ",
        " Your email address and phone number ",
        "Your IP address and browser type ",
        "Your preferences and interests ",
        "Other information you provide to us",
      ],
    },
    {
      title: "USE OF PERSONAL DATA",
      tittle2: "We use your personal data for the following purposes:",
      items: [
        "To respond to your inquiries and provide you with information about our services",
        "To provide you with our services and support",
        "To improve our website and services",
        "To comply with applicable laws and regulations",
        "To send you marketing communications",
      ],
    },
    {
      tittle2:
        "We may also use your personal data for other purposes, such as:",
      items: [
        "To conduct market research and analysis",
        "To develop and improve our services",
        "To personalize your experience on our website",
      ],
    },
    {
      title: "PROTECTION OF PERSONAL DATA",
      items: [
        "We take reasonable steps to protect your personal data from unauthorized access, disclosure, alteration, or destruction.",
        "We use industry-standard encryption and other security measures to protect your personal data.",
        "We restrict access to your personal data to only those employees, agents, and contractors who need to know that information in order to provide our services or support.",
      ],
    },
    {
      title: "SHARING OF PERSONAL DATA",
      items: [
        `We may share your personal data with our affiliates, partners, and service providers who help us provide our services.`,
        `We may also disclose your personal data as required by law or to protect our rights or the rights of others.`,
        `We will not sell or rent your personal data to third parties.`,
      ],
    },
    {
      title: "YOUR RIGHTS",
      tittle2: "You have the right to:",
      items: [
        "Access your personal data",
        "Correct or update your personal data",
        "Request deletion of your personal data",
        "Object to the processing of your personal data",
        "Request restriction of the processing of your personal data",
        "Port your personal data to another service provider",
      ],
      tittle2:
        " To exercise your rights, please contact us at [insert contact email and address]",
    },
    {
      title: "COOKIES AND TRACKING TECHNOLOGIES",
      items: [
        `We use cookies and other tracking technologies to collect information about your use of our website.`,
        "We use this information to improve our website and services, and to personalize your experience on our website.",
        "You can control the use of cookies and tracking technologies through your browser settings.",
      ],
    },
    {
      title: "SOCIAL MEDIA",
      items: [
        `We have social media presence on various platforms, such as LinkedIn and Twitter.`,
        "When you interact with us on social media, we may collect your personal data, such as your name and contact information.",
        "We use this information to respond to your inquiries and provide you with information about our services.",
      ],
    },
    {
      title: "LINKS TO THIRD PARTY WEBSITES",
      items: [
        `Our website may contain links to third party websites.`,
        "We are not responsible for the privacy practices or content of those websites.",
        "You should review the privacy policies of those websites before providing them with your personal data.",
      ],
    },
    {
      title: "CHILDREN'S PRIVACY",
      items: [
        `Our website is not intended for children under the age of 18..`,
        "We do not knowingly collect personal data from children under the age of 18.",
        "If you are under the age of 18, please do not provide us with your personal data.",
      ],
    },

    {
      title: "DATA BREACHES",
      items: [
        `In the event of a data breach, we will notify you and the relevant authorities as required by law.`,
        " We will take reasonable steps to mitigate the effects of the data breach and prevent future breaches.",
      ],
    },
    {
      title: "CHANGES TO PRIVACY POLICY",
      items: [
        `We reserve the right to modify or update this Privacy Policy at any time without prior notice.`,
        " Your continued use of our website and services following any changes to this Privacy Policy will be deemed acceptance of those changes.",
      ],
    },
    {
      title: "GOVERNING LAW",
      items: [
        `This Privacy Policy will be governed by and construed in accordance with the laws of Singapore.`,
        " Any disputes arising out of or related to this Privacy Policy will be resolved through binding arbitration in accordance with the Arbitration Rules of the Singapore International Arbitration Centre.",
      ],
    },
    {
      title: "ADDITIONAL TERMS",
      items: [
        `By using our website and services, you acknowledge that you have read, understood, and agree to be bound by this Privacy Policy.`,
        "This Privacy Policy is incorporated into and forms part of our Terms and Conditions.",
      ],
    },
    {
      title: "EFFECTIVE DATE",
      items: [`This Privacy Policy is effective as of 22nd Oct 2024.`],
    },
    {
      title: "LAST UPDATED",
      items: [`This Privacy Policy was last updated on [insert date].`],
    },
  ],
};
export default Data;
